module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/seperation-mobile-phone-2.dbec596b.png";